module.exports = __webpack_public_path__ + "static/media/logo.a72d09a3.png";